import { useState } from "react";
import PropTypes from "prop-types";

import BrokerListView from "./BrokerListView";
import ConfirmBrokerSelection from "./ConfirmBrokerSelection";

const SnaptradeModal = ({
  show,
  onHide,
  onSuccess,
  isConnectedPage = false,
}) => {
  const [showBrokerList, setShowBrokerList] = useState(show);
  const [showBrokerConfirmSelection, setShowBrokerConfirmSelection] =
    useState(false);
  const [selectedBroker, setSelectedBroker] = useState({});

  const toggleBrokerList = () => {
    setShowBrokerList(!showBrokerList);
  };

  const toggleBrokerConfirmSelection = () => {
    setShowBrokerConfirmSelection(!showBrokerConfirmSelection);
  };

  const handleBrokerConfirmSelectionBack = () => {
    toggleBrokerConfirmSelection();
    toggleBrokerList();
  };

  const handleSelectedBroker = (broker) => {
    setSelectedBroker(broker);
    handleBrokerConfirmSelectionBack();
  };

  return (
    <>
      {showBrokerList && (
        <BrokerListView
          show={showBrokerList}
          onHide={onHide}
          onBrokerSelect={handleSelectedBroker}
          isConnectedPage={isConnectedPage}
        />
      )}

      {showBrokerConfirmSelection && (
        <ConfirmBrokerSelection
          show={showBrokerConfirmSelection}
          onHide={onHide}
          onBack={handleBrokerConfirmSelectionBack}
          broker={selectedBroker}
          onSuccess={onSuccess}
        />
      )}
    </>
  );
};

SnaptradeModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onSuccess: PropTypes.func,
  isConnectedPage: PropTypes.bool,
};

export { SnaptradeModal };
